<template>
	<section class="marketing-section bg-color-bg-tertiary pb-300">
		<div class="container">
			<VentureCapitalSectionHeader :header="header" />
			<div class="grid display-flex-smo flex-direction-column-smo">
				<div
					:class="[
						'col-5-md pr-500-md',
						{
							'position-sticky-md': !appStore.isMobile
						}
					]"
				>
					<h3 class="heading-2 font-weight-lighter line-height-125"
						>Vast majority of returns accrue in the private markets</h3
					>
					<p>
						With companies staying private longer, the vast majority of the returns from private tech has
						accrued to the private investors before the public offering. Plus, access is gated, with hefty
						tolls, by fund managers and growth equity firms, just as in the real estate private equity
						world.
					</p>
					<p class="my-150">
						During the 90's and early 00's, companies like Amazon and Google went public relatively soon in
						their growth cycle, while companies today are waiting on average 10 years longer. The result:
						individual investors confined to the public markets are missing out on a substantial portion of
						the returns generated by the next generation of industry leaders.
					</p>
				</div>
				<div class="col-7-md mt-50-md mt-300-smo">
					<TechCompaniesAverageIpoChart />
					<p class="body-xs text-color-content-tertiary font-style-italic mt-0 text-align-center-md">
						Source: <BaseLink class="muted cta-link--rust" :link="UFLink" />
					</p>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
import { LandingPageHeader, Link } from 'types/layout';
import { computed } from 'vue';
import TechCompaniesAverageIpoChart from '@components/charts/tech-companies-average-ipo-chart.vue';
import { useAppStore } from '@stores/app';
import VentureCapitalSectionHeader from '@components/marketing-site/venture-capital/venture-capital-section-header.vue';

const appStore = useAppStore();

const UFLink: Link = {
	href: 'https://site.warrington.ufl.edu/ritter/files/IPOs-Tech.pdf',
	target: '_blank',
	text: 'University of Florida Warrington College of Business'
};

const header = computed((): LandingPageHeader => {
	return {
		heading: appStore.isMobile ? 'Same problem, <br/> different asset' : 'Same problem, different asset',
		summary: [
			`Like real estate, the world of investing in private technology companies has remained almost
					entirely inaccessible to individuals, despite the fact that as an asset class it has proven to be
					one of (if not the) best performing investment strategies of the past 50 years.`
		],
		title: 'Why Venture'
	};
});
</script>
<style lang="scss" scoped>
.position-sticky-md {
	top: 200px;
}
</style>
